import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-errors" }
const _hoisted_2 = { class: "c-error" }
const _hoisted_3 = { style: {"flex-wrap":"wrap"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("既に会員情報が登録されています。 ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "こちら", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("からログインしてください。 ")
const _hoisted_7 = { class: "p-fields p-fields--confirm" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "性別", -1)
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "c-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "誕生日", -1)
const _hoisted_13 = { class: "c-field__body" }
const _hoisted_14 = {
  key: 0,
  class: "c-field"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "規約・プライバシーガイドライン", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "同意する")
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "c-field has-submit has-mt" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "編集画面に戻る", -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("p", { class: "c-error" }, _toDisplayString(_ctx.errorMsgRef), 513), [
        [_vShow, _ctx.errorMsgRef]
      ]),
      _withDirectives(_createElementVNode("p", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: { name: _ctx.routeNames.LOGIN },
            class: "c-link c-link--primary"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_6
        ])
      ], 512), [
        [_vShow, _ctx.isDispErrorMsgRef]
      ])
    ], 512), [
      [_vShow, _ctx.errorMsgRef || _ctx.isDispErrorMsgRef]
    ]),
    _createElementVNode("fieldset", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.gender === null || _ctx.userBase.commonAttrInfo.gender === "" || _ctx.userBase.commonAttrInfo.gender === undefined) ? "未選択" : (_ctx.userBase.commonAttrInfo.gender === "無回答") ? "回答しない" : _ctx.userBase.commonAttrInfo.gender), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.year) ? "" : _ctx.date.year + "年"), 1),
            _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.month) ? "" : _ctx.date.month + "月"), 1),
            _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.day) ? "" : _ctx.date.day + "日"), 1)
          ])
        ])
      ]),
      (_ctx.firstServiceReg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "button",
          class: "ha-btn is-submit",
          disabled: _ctx.isDeterringRef,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.upsert, this)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userBase.identityId ? "更新する" : "登録する"), 1)
        ], 8, _hoisted_19),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: _ctx.prevRoute }))),
          class: _normalizeClass(["ha-btn ha-btn--outline", { 'is-disabled':_ctx.isDeterringRef }])
        }, _hoisted_21, 2)
      ])
    ])
  ], 64))
}